import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

import Step1 from './ExistingCustomerStep1'
import Step2 from './ExistingCustomerStep2'
import Step3 from './ExistingCustomerStep3'

import AppStore from '../../../stores/AppStore'

function ExistingCustomer ({
  intl: { formatMessage, locale },
  data,
  data: { customers: { data: { items: customersData } }, groups },
  params: { selectedCustomer },
  params,
  onSubmit,
  customerID,
  previousPage,
  nextPage,
  page,
  currentData,
}) {
  const navigate = useNavigate()

  const [company, setCompany] = useState('')
  const [fromGroup, setFromGroup] = useState('')
  const [toGroup, setToGroup] = useState('')
  const [language, setLanguage] = useState(locale)
  const [invalid, setInvalid] = useState(false)
  const [saved, setSaved] = useState(false)
  const [shouldHide, setShouldHide] = useState(true)
  const [selectedState, setSelectedState] = useState(null)

  const getData = useCallback(() => {
    if (!customerID) return

    AppDispatcher.dispatch({
      action: 'get-customer-relations',
      customerID,
      relation: 'Distributor',
    })
  }, [customerID])

  useEffect(() => {
    getData()
  }, [getData])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [])

  const handleChange = useCallback((field, value, callback) => {
    const newValue = value

    // Update the appropriate state based on field
    if (field === 'company') setCompany(newValue)
    if (field === 'fromGroup') setFromGroup(newValue)
    if (field === 'toGroup') setToGroup(newValue)
    if (field === 'language') setLanguage(newValue)
    if (field === 'invalid') setInvalid(newValue)
    if (field === 'saved') setSaved(newValue)
    if (field === 'shouldHide') setShouldHide(newValue)
    if (field === 'selectedState') setSelectedState(newValue)

    if (callback) callback()
  }, [])

  const step1Callback = useCallback((data) => {
    setCompany(data)
    nextPage()
  }, [nextPage])

  const step2Callback = useCallback((fG, tG, sT) => {
    setFromGroup(fG)
    setToGroup(tG)
    setSelectedState(sT)
    nextPage()
  }, [nextPage])

  const backToUsers = useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()
    navigate(`/${customerID}/distributor/transferDevices`)
  }, [navigate])

  const unhide = useCallback(() => {
    setShouldHide(false)
  }, [])

  const user = AppStore.getUser()

  const SelectCustomer = formatMessage({
    id: 'customer.selectCustomer',
    defaultMessage: 'Select Customer',
    description: 'Select Customer label',
  })

  const customerOptions = [{
    value: '',
    name: SelectCustomer,
    disabled: true,
  }]

  let customers = []

  if (user.permissions.level === 30) {
    customers = (!!user && user.customers) || []
  } else {
    customers = customersData || []
  }

  customers
    .sort((a, b) => {
      if (!a.customer_name) return true
      if (!b.customer_name) return false
      return a.customer_name.localeCompare(b.customer_name)
    })
    .map(
      (customer) => customerOptions.push({
        value: customer.id,
        name: customer.customer_name,
      })
    )

  return (
    <div>
      {page === 1 &&
        (
          <Step1
            data={data}
            step1Callback={step1Callback}
            customerOptions={customerOptions}
            defaultCustomer={selectedCustomer}
            customerID={customerID}
            onSubmit={nextPage}
          />
        )}
      {page === 2 &&
        (
          <Step2
            data={data}
            previousPage={previousPage}
            step2Callback={step2Callback}
            customerOptions={customerOptions}
            defaultToGroup={toGroup}
            defaultFromGroup={fromGroup}
            defaultSelectedState={selectedState}
            company={company}
            groups={groups}
            currentData={currentData}
            onSubmit={nextPage}
          />
        )}
      {page === 3 &&
          (
            <Step3
              data={data}
              toGroup={toGroup}
              fromGroup={fromGroup}
              company={company}
              params={params}
              groups={groups}
              customerOptions={customerOptions}
              previousPage={previousPage}
              onSubmit={onSubmit}
            />
          )}
    </div>
  )
}

export default injectIntl(ExistingCustomer)
